import Loadable from "react-loadable";

export default Loadable({
  loader: () => import("../containers/Editor"),
  loading() {
    return null;
  }
});



// WEBPACK FOOTER //
// ./src/loadables/Editor.js